<template>
  <div class=" col-12 col-xl-9">
    <modal name="modal-profile-delete">
      <div class="card h-100">
        <div class="card-header bg-primary">
          <p class="text-white text-lg text-center">Mein Profil löschen</p>
        </div>
        <div class="card-body">
          <p class="text-danger mt-3 text-center text-vcenter ">
            Bist du dir sicher das dein Profil gelöscht werden soll?
          </p>
          <button
            type="submit"
            class="btn btn-primary mt-5"
            @click="markAsDelete"
          >
            Profil löschen
          </button>
          <button
            type="submit"
            class="btn btn-primary float-right mt-5"
            @click="$modal.hide(`modal-profile-delete`)"
          >
            Abbruch
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import logout from "@/js/logout";
export default {
  methods: {
    markAsDelete() {
      this.$http
        .post(`/api/v1/userDeletion/`, { user_id: Laravel.user.id })
        .then(() => {
          logout("/login");
        });
    }
  }
};
</script>
